export enum State {
  HOME = 'home',

  DOCUMENT_UPLOAD = 'document-upload',

  HANDWRITTEN_IDENTITY_INFO = 'handwritten-identity-info',
  HANDWRITTEN_IDENTITY_UPLOAD = 'handwritten-identity-upload',

  DONE = 'done',
  ABORT = 'abort',
}
